const angular = require('angular');
const app = angular.module('learn-resources');
/**
 * Access Profile Resource
 * @argument {$resource} $resource injected to define a resource api
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.factory('AccessProfiles', ['$resource', 'appConfiguration', function ($resource, appConfiguration) {

  return $resource(appConfiguration.apiUrl + '/learn/v3/access-profiles/:subresource/:subsubresource', null, {
    get: {params: {subresource: ''}, method: 'GET', isArray: false},
    find: {params: {subresource: ''}, method: 'GET', isArray: true},
    count: {params: {subresource: 'count'}, method: 'GET', isArray: false},
    userCount: {params: {subresource: 'user-count'}, method: 'GET', isArray: false},
    users: {params: {subsubresource: 'users'}, method: 'GET', isArray: true},
    create: {params: {subresource: ''}, method: 'POST', isArray: false},
    update: {params: {subresource: ''}, method: 'POST', isArray: false},
    queryAssign: {params: {subresource: 'query-assign'}, method: 'POST', isArray: false},
    duplicate: {params: {subresource: 'duplicate'}, method: 'POST', isArray: false},
    delete: {params: {subresource: ''}, method: 'DELETE', isArray: false}
  });
}]);
